import { ComponentProps, useContext } from 'react';
import Dialog from '@pelckmans/elementis/components/dialog';
import ModalContext from '../../../../../contexts/ModalContext';
import MaterialDialogHeader from '../../../components/MaterialDialogHeader';
import PdfjsLinkTargets from '../../../../../constants/PdfjsLinkTargets';
import DownloadDisclaimer from '../DownloadDisclaimer';
import { useTranslation } from 'react-i18next';

type PdfPreviewModalProps = {
  id: string;
  url: string;
  linkTarget?: 'new-window' | 'same-window';
  headerProps: Pick<ComponentProps<typeof MaterialDialogHeader>, 'title' | 'tags' | 'titleTooltip'>;
  downloadUrl?: string;
};

export default function PdfPreviewModal({
  id,
  url,
  linkTarget = 'new-window',
  downloadUrl,
  headerProps,
}: PdfPreviewModalProps) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  function handleClose() {
    closeModal(id);
  }

  return (
    <Dialog
      id={id}
      modal
      onClose={handleClose}
      className="modal-with-full-height"
      aria-label={t('PAGES.TOC_LEVEL.MODALS.PDF_PREVIEW.A11Y_LABEL')}
    >
      <MaterialDialogHeader
        title={headerProps.title}
        titleTooltip={headerProps.titleTooltip}
        onClose={handleClose}
        downloadUrl={downloadUrl}
        tags={headerProps.tags}
      />
      <Dialog.Body
        alertGroupProps={
          !downloadUrl ? { 'aria-label': undefined, role: undefined, children: <DownloadDisclaimer /> } : undefined
        }
      >
        <object
          aria-label="pdf-preview"
          className="pdf-preview"
          type="text/html"
          data={`${process.env.PUBLIC_URL}/pdfjs/web/viewer.html?file=${encodeURIComponent(url)}&externallinktarget=${
            PdfjsLinkTargets[linkTarget]
          }`}
        />
      </Dialog.Body>
    </Dialog>
  );
}
